import styled from 'styled-components';
import { Input as MaterialInput } from '@material-ui/core';

export const Input = styled(MaterialInput)`
  width: ${props => props.width || "100%"};
  float: ${props => props.float || "inherit"};
`;

export default Input;
